import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { strongPasswordValidator } from '../../core/validators/password.validator';

@Component({
  selector: 'app-change-password',
  imports: [ReactiveFormsModule, NgIf],
  templateUrl: './change-password.html',
  styleUrl: './change-password.scss',
})
export class ChangePassword {
  step: 'otp' | 'password' = 'otp';

  otpForm!: FormGroup;
  passwordForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.minLength(4)]],
    });

    this.passwordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(8), strongPasswordValidator()]],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validators: (form: AbstractControl): ValidationErrors | null => {
          const p = form.get('password')?.value;
          const c = form.get('confirmPassword')?.value;
          return p && c && p !== c ? { passwordMismatch: true } : null;
        },
      },
    );
  }

  verifyOtp() {
    if (this.otpForm.invalid) return;

    // TODO: actual backend verification
    this.step = 'password';
  }

  updatePassword() {
    if (this.passwordForm.invalid) return;

    const { password, confirmPassword } = this.passwordForm.value;

    if (password !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    // TODO: backend call
    alert('Password updated successfully');
  }

  hasUppercase(): boolean { return /[A-Z]/.test(this.passwordForm.get('password')?.value ?? ''); }
  hasLowercase(): boolean { return /[a-z]/.test(this.passwordForm.get('password')?.value ?? ''); }
  hasDigit(): boolean { return /\d/.test(this.passwordForm.get('password')?.value ?? ''); }
  hasSpecial(): boolean { return /[^A-Za-z0-9]/.test(this.passwordForm.get('password')?.value ?? ''); }
}
